import { postListBulkEntries } from 'Services';
import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { callAll, RQ_LIST_ENTRIES, RQ_LIST_ENTRIES_BULK } from 'Utils';
import { AxiosResponse } from 'axios';

type HookArgs = {
    listId: number;
    mutationOptions?: Omit<MutationOptions<AxiosResponse<any>, any, any, any>, 'mutationKey'>;
};
function useBulkListEntry({ listId, mutationOptions }: HookArgs) {
    const queryClient = useQueryClient();
    const defaultSuccessHandler = () => {
        queryClient.invalidateQueries([RQ_LIST_ENTRIES]);
    };
    return useMutation([RQ_LIST_ENTRIES_BULK, listId], postListBulkEntries(listId), {
        ...mutationOptions,
        onSuccess: callAll(defaultSuccessHandler, mutationOptions?.onSuccess)
    });
}

export default useBulkListEntry;
